module.exports = __webpack_public_path__ + "img/Coasters.7f1adbac.jpg";